export default "__VITE_PUBLIC_ASSET__4bafd0db__"